export default __webpack_public_path__ + "logo.png?80b680171938be5a06e3dfd8359239ff";